import React, { useState ,useEffect} from "react";
import MainContainer from '../../components/MainContainer';
import { headerDataAssignment } from '../../data/modules/assignment-header';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Title from '../../components/Title';
import Spacer from '../../components/Spacer';
import Paper from '@mui/material/Paper';
import { MenuItem, Select, InputLabel, FormControl, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Message from "../tools/Message";
import UserNotactifService from "../../services/UserNotactifService";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ExcelJS from 'exceljs';
import TableViewIcon from '@mui/icons-material/TableView';
import { saveAs } from 'file-saver';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import frLocale from 'date-fns/locale/fr';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  datePicker: {
    width: '100%',
  },
}));

export default function Historyfinancement() {
 
     const classes = useStyles();
     const [message, setMessage] = React.useState({
             open: false,
             color: "green",
             messageInfo: "",
           });
     const { open, color, messageInfo } = message;
     const[columns,setColumns]=useState([]);
     const[direction,setDirection]=useState([]);
     
     // État pour le mode de filtrage
     const [filterMode, setFilterMode] = useState('month'); // 'month' ou 'date'
     
     // États pour le filtrage par mois/année
     const getPreviousMonth = () => {
        const now = new Date();
        const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        return previousMonth.getMonth() + 1;
      };
      
     const initialYear = 2025;
     const initialMonth = getPreviousMonth();
     const [year,setYear]=useState(initialYear);
     const [month, setMonth] = useState(initialMonth);
     
     // États pour le filtrage par date
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);
     
     const [isLoading, setIsLoading] = useState(false);
     const [isExporting, setIsExporting] = useState(false);
     const [rows,setRows]=useState([]);
     const[openLoadingSimpleBackdrop,setOpenLoadingSimpleBackdrop]= useState(false);
     
     const getYearRange = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 2025; 
    
        const years = [];
        for (let year = startYear; year <= currentYear; year++) {
          years.push(year);
        }
        return years;
    };
    
    const years = getYearRange();

    function handleChange(ev) {
        const monthSelected = ev.target.value;
        setMonth(monthSelected);
    }

    function handleChangeyear(ev) {
        const yearSelected = ev.target.value;
        setYear(yearSelected);
    }
    
    function handleFilterModeChange(ev) {
        setFilterMode(ev.target.value);
    }

    function handleReset() {
        // Réinitialiser les états de filtrage par mois/année
        setYear(initialYear);
        setMonth(initialMonth);
        setFilterMode('month');
        
        // Réinitialiser les dates
        setStartDate(null);
        setEndDate(null);
        
        // Recharger les données par défaut
        setOpenLoadingSimpleBackdrop(true);
        UserNotactifService.suivifinancement(initialYear, initialMonth)
            .then((result) => {
                if (result && result.data) {
                    setRows(result.data);
                    setColumns(result.column || []);
                    setDirection(result.direction || []);
                } else {
                    setRows([]);
                    setColumns([]);
                    setDirection([]);
                }
                setOpenLoadingSimpleBackdrop(false);
            })
            .catch(() => {
                setRows([]);
                setColumns([]);
                setDirection([]);
                setOpenLoadingSimpleBackdrop(false);
            });
    }

    function handleFilter()
    {
        setIsLoading(true);
        setOpenLoadingSimpleBackdrop(true);
        
        if (filterMode === 'date') {
            // Validation des dates
            if (!startDate || !endDate) {
                setMessage({ ...message, open: true, color: 'red',messageInfo: "Veuillez sélectionner une date de début et une date de fin." });
                setIsLoading(false);
                setOpenLoadingSimpleBackdrop(false);
                return;
            }
            
            // Format des dates pour l'API
            const formattedStartDate = startDate.toISOString().split('T')[0];
            const formattedEndDate = endDate.toISOString().split('T')[0];
            
            UserNotactifService.suivifinancementByDate(formattedStartDate, formattedEndDate)
                .then((result) => {
                   if (result && result.data) {
                     setRows(result.data);
                     setColumns(result.column || []);
                     setDirection(result.direction || []);
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                   } else {
                     setMessage({ ...message, open: true, color: 'red',messageInfo: "Aucune donnée ne correspond aux filtres appliqués." });
                     setRows([]);
                     setColumns([]);
                     setDirection([]);
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                   }
                 })
                 .catch(() => {
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                 });
        } else {
            // Filtrage par mois/année
            UserNotactifService.suivifinancement(year,month).then((result) => {
                   if (result && result.data) {
                     setRows(result.data);
                     setColumns(result.column || []);
                     setDirection(result.direction || []);
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                   } else {
                     setMessage({ ...message, open: true, color: 'red',messageInfo: "Aucune donnée ne correspond aux filtres appliqués." });
                     setRows([]);
                     setColumns([]);
                     setDirection([]);
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                   }
                 })
                 .catch(() => {
                     setIsLoading(false);
                     setOpenLoadingSimpleBackdrop(false);
                 });
        }
    }

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    const exportExcel = async () => {
      if (rows.length === 0 || columns.length === 0 || direction.length === 0) {
          setMessage({ ...message, open: true, color: 'red',messageInfo: "Aucune donnée à exporter." });
          return;
      }
      
      try {
          setIsExporting(true);
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Répartition');

          // Récupérer et ajouter le logo
          const logoUrl = `${process.env.PUBLIC_URL}/assets/images/fid_logo.png`;

          const logoResponse = await fetch(logoUrl);
          const logoBuffer = await logoResponse.arrayBuffer();

          const logoImageId = workbook.addImage({
            buffer: logoBuffer,
            extension: 'png',
          });

          // Insérer le logo (position: A1)
          worksheet.addImage(logoImageId, {
              tl: { col: 0, row: 0 },
              ext: { width: 100, height: 50 }
          });

          // Construire le titre selon le mode de filtrage
          let titleText = '';
          let subtitleText = '';
          const currentDate = new Date().toLocaleDateString('fr-FR');
          
          if (filterMode === 'month') {
              const monthDate = new Date(year, month - 1, 1);
              const monthName = monthDate.toLocaleString('fr-FR', { month: 'long' });
              titleText = `Répartition du personnel par financement - ${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`;
              subtitleText = `Période : ${monthName} ${year}`;
          } else {
              const formattedStart = startDate.toLocaleDateString('fr-FR');
              const formattedEnd = endDate.toLocaleDateString('fr-FR');
              titleText = `Répartition du personnel par financement`;
              subtitleText = `Période : du ${formattedStart} au ${formattedEnd}`;
          }

          const titleCell = worksheet.getCell('C1');
          titleCell.value = titleText;
          titleCell.font = { 
            size: 16, 
            bold: true,
            name: 'Arial'
          };
          titleCell.alignment = { 
            vertical: 'middle', 
            horizontal: 'center',
            wrapText: true 
          };
          worksheet.getRow(1).height = 40;

          // Sous-titre
          const subtitleRow = worksheet.addRow([]);
          subtitleRow.getCell(3).value = subtitleText;
          subtitleRow.getCell(3).font = { size: 12, bold: true };
          subtitleRow.getCell(3).alignment = { vertical: 'middle', horizontal: 'center' };

          // Date d'édition
          const dateRow = worksheet.addRow([]);
          dateRow.getCell(3).value = `Édité le ${currentDate}`;
          dateRow.getCell(3).font = { size: 11, italic: true };
          dateRow.getCell(3).alignment = { vertical: 'middle', horizontal: 'center' };
          
          // Ligne vide
          worksheet.addRow([]);

          // En-têtes du tableau
          const header = ["Direction/Financement", ...columns.map(c => c.funding_code), "Total général"];
          const headerRow = worksheet.addRow(header);

          // Appliquer couleur bleue à l'en-tête
          headerRow.eachCell((cell) => {
              cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FF4472C4' },
              };
              cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
              
              // S'assurer que l'en-tête est verrouillé
              cell.protection = { locked: true };
          });

          // Remplir les données des directions
          direction.forEach(dir => {
            const rowValues = [dir.direction_code];

            let rowSum = 0;

            columns.forEach(col => {
              const value = parseInt(getValue(dir.direction_id, col.funding_id), 10);
              rowValues.push(value);
              rowSum += value;
            });

            rowValues.push(rowSum);

            const dataRow = worksheet.addRow(rowValues);
            
            // Verrouiller toutes les cellules de chaque ligne de données
            dataRow.eachCell((cell) => {
                cell.protection = { locked: true };
            });
          });

          // Ligne de total général
          const totalRow = ["Total général"];
          let grandTotal = 0;

          columns.forEach(col => {
            const colSum = direction.reduce((sum, dir) => {
              return sum + parseInt(getValue(dir.direction_id, col.funding_id), 10);
            }, 0);

            totalRow.push(colSum);
            grandTotal += colSum;
          });

          totalRow.push(grandTotal);

          const footerRow = worksheet.addRow(totalRow);

          // Style pour la ligne de total
          footerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFE2E2E2" }
            };
            cell.alignment = { horizontal: "center" };
            cell.protection = { locked: true };
          });

          // Ajuster la largeur des colonnes
          worksheet.columns.forEach((col) => {
            let maxLength = 0;
            col.eachCell((cell) => {
              const len = cell.value ? cell.value.toString().length : 10;
              if (len > maxLength) maxLength = len;
            });
            col.width = maxLength + 2;
          });

          // Fusionner les cellules pour le titre principal
          const totalColumns = columns.length + 2;
          const mergeEndColumn = String.fromCharCode(65 + totalColumns - 1);
          worksheet.mergeCells(`C1:${mergeEndColumn}1`);
          worksheet.mergeCells(`C2:${mergeEndColumn}2`);
          worksheet.mergeCells(`C3:${mergeEndColumn}3`);

          // Centrer les titres
          worksheet.getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' };
          worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };
          worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'center' };

          // PROTECTION DE LA FEUILLE - Tout verrouiller
          worksheet.protect('REPARTITION123', {
              selectLockedCells: false,     
              selectUnlockedCells: false,  
              formatCells: false,           
              formatColumns: false,          
              formatRows: false,            
              insertColumns: false,          
              insertRows: false,            
              insertHyperlinks: false,       
              deleteColumns: false,         
              deleteRows: false,            
              sort: false,                   
              autoFilter: false,            
              pivotTables: false,            
              editObjects: false,            
              editScenarios: false,          
              sheet: true,                  
          });

          // Générer et télécharger le fichier Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
              const blob = new Blob([buffer], { type: 'application/octet-stream' });
              let fileName = '';
              
              if (filterMode === 'month') {
                  const monthDate = new Date(year, month - 1, 1);
                  const monthName = monthDate.toLocaleString('fr-FR', { month: 'long' });
                  fileName = `Repartition_financement_${monthName}_${year}.xlsx`;
              } else {
                  const formattedStart = startDate.toISOString().split('T')[0];
                  const formattedEnd = endDate.toISOString().split('T')[0];
                  fileName = `Repartition_financement_${formattedStart}_${formattedEnd}.xlsx`;
              }
              
              saveAs(blob, fileName);
              setIsExporting(false);
          });
      } catch (error) {
          console.error('Erreur lors de la génération du fichier Excel:', error);
          setMessage({ ...message, open: true, color: 'red',messageInfo: "Erreur lors de l'exportation du fichier Excel." });
          setIsExporting(false);
      }
  };

    
      useEffect(() => {
           setOpenLoadingSimpleBackdrop(true);
            UserNotactifService.suivifinancement(year,month).then((result) => {
                   if (result && result.data) {
                     setRows(result.data);
                     setColumns(result.column || []);
                     setDirection(result.direction || []);
                     setOpenLoadingSimpleBackdrop(false);
                   } else {
                     setRows([]);
                     setColumns([]);
                     setDirection([]);
                     setOpenLoadingSimpleBackdrop(false);
                   }
                 })
                 .catch(() => {
                     setOpenLoadingSimpleBackdrop(false);
                 });
      }, []);

      const getValue = (directionId, fundingId) => {
        const row = rows.find(r => r.direction_id === directionId && r.funding_id === fundingId);
        return row ? parseInt(row.nombre_user, 10) : 0;
      };

      
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
      <MainContainer {...headerDataAssignment}>
                 <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
                <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
                <Grid container spacing={3}> 
                         <Grid item xs={2}>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                onClick={handleFilter}
                                loading={isLoading}
                                loadingIndicator="Chargement..."
                                style={{
                                    fontWeight: 600,
                                    width: "100%",
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                startIcon={<SearchIcon style={{ marginRight: '8px' }} />} 
                            >
                                Filtrer
                            </LoadingButton>
                       </Grid>  
                       <Grid item xs={2}>
                            <LoadingButton
                                variant="outlined"
                                color="secondary"
                                onClick={handleReset}
                                style={{
                                    fontWeight: 600,
                                    width: "100%",
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                startIcon={<ClearIcon style={{ marginRight: '8px' }} />} 
                            >
                                Réinitialiser
                            </LoadingButton>
                       </Grid>
                        <Grid item xs={2}>
                                   <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        onClick={exportExcel} 
                                        loading={isExporting}
                                        loadingIndicator="Chargement..."
                                        style={{ 
                                            fontWeight: 600, 
                                            width: "100%", 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center' 
                                        }}
                                        startIcon={<TableViewIcon style={{ marginRight: '8px' }} />}
                                    >
                                        Export Excel
                                    </LoadingButton>
                        </Grid>
                       <Grid item xs={6}></Grid>
                       <Grid item xs={3}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Mode de filtrage</InputLabel>
                            <Select
                                label="Mode de filtrage"
                                value={filterMode}
                                onChange={handleFilterModeChange}
                            >
                                <MenuItem value="month">Par mois/année</MenuItem>
                                <MenuItem value="date">Par période de dates</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        
                        {filterMode === 'month' ? (
                          <>
                            <Grid item xs={3}>
                              <FormControl fullWidth variant="outlined" size="small">
                              <Select
                                  labelId="demo-simple-select-outlined-label"
                                  id="demo-simple-select-outlined"
                                  value={year}
                                  name="year"
                                  onChange={handleChangeyear}
                              >
                                  {years.map((year, index) => (
                                      <MenuItem key={index} value={year}>
                                          {year}
                                      </MenuItem>
                                  ))}
                              </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined"
                                           value={month}
                                          name="month"
                                          onChange={handleChange}
                                        >
                                            <MenuItem value="1">Janvier</MenuItem>
                                            <MenuItem value="2">Février</MenuItem>
                                            <MenuItem value="3">Mars</MenuItem>
                                            <MenuItem value="4">Avril</MenuItem>
                                            <MenuItem value="5">Mai</MenuItem>
                                            <MenuItem value="6">Juin</MenuItem>
                                            <MenuItem value="7">Juillet</MenuItem>
                                            <MenuItem value="8">Août</MenuItem>
                                            <MenuItem value="9">Septembre</MenuItem>
                                            <MenuItem value="10">Octobre</MenuItem>
                                            <MenuItem value="11">Novembre</MenuItem>
                                            <MenuItem value="12">Décembre</MenuItem>
                                        </Select>
                                    </FormControl>
                             </Grid>
                          </>
                        ) : (
                          <>
                            <Grid item xs={3}>
                              <DatePicker
                                label="Date de début"
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                renderInput={(params) => <TextField {...params} className={classes.datePicker} />}
                                inputFormat="dd/MM/yyyy"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <DatePicker
                                label="Date de fin"
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                renderInput={(params) => <TextField {...params} className={classes.datePicker} />}
                                inputFormat="dd/MM/yyyy"
                                minDate={startDate}
                              />
                            </Grid>
                          </>
                        )}
                </Grid>
                <Grid container spacing={3}>     
                   <Grid item xs={12}>
                     <Paper className={classes.paper} variant="outlined">
                        <Title style={{ textAlign: "center" }}>Répartition du personnel par financement</Title>
                        <Spacer y={2} />
                       <TableContainer sx={{ maxHeight: 530 }}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ minWidth: 100 }}>
                                Direction/Financement 
                              </TableCell>
                              {columns.map((column) => (
                                <TableCell
                                  key={column.funding_id}
                                  style={{ minWidth: 100 }}
                                  align="center"
                                >
                                  {column.funding_code}
                                </TableCell>
                              ))}
                              <TableCell style={{ minWidth: 50 }} align="center">
                                Total général
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {direction.map((dir) => {
                              const rowSum = columns.reduce((sum, column) => {
                                return sum + getValue(dir.direction_id, column.funding_id);
                              }, 0);
                              
                              return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={dir.direction_id}>
                                  <TableCell>
                                    {dir.direction_code}
                                  </TableCell>
                                  {columns.map((column) => (
                                    <TableCell
                                      key={column.funding_id}
                                      style={{ minWidth: 50 }}
                                      align="center"
                                    >
                                      {getValue(dir.direction_id, column.funding_id)}
                                    </TableCell>
                                  ))}
                                  <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                                    {rowSum} 
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            
                            <TableRow sx={{ backgroundColor: 'action.hover' }}>
                              <TableCell sx={{ fontWeight: 'bold' }}>
                                Total général
                              </TableCell>
                              {columns.map((column) => {
                                const columnSum = direction.reduce((sum, dir) => {
                                  return sum + getValue(dir.direction_id, column.funding_id);
                                }, 0);
                                
                                return (
                                  <TableCell
                                    key={column.funding_id}
                                    align="center"
                                    sx={{ fontWeight: 'bold' }}
                                  >
                                    {columnSum} 
                                  </TableCell>
                                );
                              })}
                              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                                {direction.reduce((totalSum, dir) => {
                                  const rowSum = columns.reduce((sum, column) => {
                                    return sum + getValue(dir.direction_id, column.funding_id);
                                  }, 0);
                                  return totalSum + rowSum;
                                }, 0)} 
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Grid>
            </Grid>
      </MainContainer>
    </LocalizationProvider>
  );
}